function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Diversity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#33C481"
    },
    cx: 13,
    cy: 13,
    r: 7
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 28,
    y1: 13,
    x2: 42,
    y2: 13
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#42A3F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#42A4EB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M40.133,20H29.867C28.836,20,28,19.164,28,18.133V7.867C28,6.836,28.836,6,29.867,6h10.267 C41.164,6,42,6.836,42,7.867v10.267C42,19.164,41.164,20,40.133,20z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 27.3502,
    y1: 34.6792,
    x2: 42.6498,
    y2: 34.6792
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C965EB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C767E5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_2_)"
    },
    d: "M34.454,27.536l-6.721,4.883c-0.325,0.236-0.462,0.656-0.337,1.038l2.567,7.901 C30.087,41.741,30.444,42,30.846,42h8.308c0.402,0,0.759-0.259,0.883-0.642l2.567-7.901c0.124-0.383-0.012-0.802-0.337-1.038 l-6.721-4.883C35.22,27.299,34.78,27.299,34.454,27.536z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED6C47"
    },
    d: "M11.715,28.666L4.832,40.613C4.477,41.23,4.922,42,5.634,42H19.4c0.712,0,1.157-0.77,0.801-1.387 l-6.883-11.947C12.962,28.049,12.071,28.049,11.715,28.666z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Diversity);
export default __webpack_public_path__ + "static/media/icons8-diversity.19f54f9f5846208fd55c3f235532b4c7.svg";
export { ForwardRef as ReactComponent };